import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import "../assets/stylesheets/Rocket.scss";
import Breadcrumb from "../components/Breadcrumb";
import QrCodeModal from "../components/QrCodeModal";

import { autorun } from 'mobx';
import DropdownLessonByDay from "./DropdownLessonByDay";
import DropdownRocketClass from "./DropdownRocketClass";
import { getWebUri } from '../utils/api';


@inject('Navigator', 'StudentStore', 'AuthStore', 'SchoolStore')
@observer
export default class Rocket extends Component {

    static breadcrumbSegments = [
        {
            title: "Portal do professor",
            uri: "/"
        },
        {
            title: "Registrar rocket",
            uri: ""
        }
    ]; 

    constructor(props) {
        super(props);

        this.state = {
            percentage: '0',
            students: [],
            change: false,
        }

        //Unset Engagament
        this.props.SchoolStore.isEngagement = false;
    }


componentDidMount() {
    const { AuthStore, SchoolStore } = this.props;

    this.disposeAutorun = autorun(() => {
        const user = AuthStore.user;
        const units = AuthStore.units;

        if (!user || !units || units.length === 0) return;

        const selectedUnit = units[0];

        SchoolStore.schoolSelected = {
            value: selectedUnit.id,
            label: selectedUnit.name
        };

        SchoolStore.getClassesBySchool(selectedUnit.id, user)
            .then(() => {
                if (SchoolStore.classes.length > 0) {
                    const selectedClass = SchoolStore.classes[0];
                    SchoolStore.classSelected = {
                        value: 0,
                        label: selectedClass.name
                    };
                    SchoolStore.currentClass = selectedClass;
    if (selectedClass.unit_id && selectedClass.teacher_id) {
                    SchoolStore.getLessonsByCLassAndDay(selectedClass.unit_id, selectedClass.teacher_id)
                }
            }
            });
    });
}

componentWillUnmount() {
    if (this.disposeAutorun) {
        this.disposeAutorun();
    }
}

    handleBreadcrumbClick(uri) {
        this.props.ConfigStore.animationType = "right";
        this.props.Navigator.push(uri);
    }

handleGenerateQRCode() {
    const { AuthStore, SchoolStore } = this.props;
    const { schoolSelected, classSelected, lessonSelected } = SchoolStore;
    const user = AuthStore.user;

    if (schoolSelected && classSelected && lessonSelected) {
        const lesson = SchoolStore.lessons[lessonSelected.value];

        const unit_id = SchoolStore.currentClass.unit_id;
        const module_id = lesson.module_id;
        const conquer_trail_id = lesson.conquer_trail_id;
        const lesson_id = lesson.lesson_id;
        const teacher_id = SchoolStore.currentClass.teacher_id;
        const teacher_name = user.name;
        const class_date = lesson.class_date;

        const qrCodeString = `${getWebUri()}/rocket/guest?module_id=${module_id}&conquer_trail_id=${conquer_trail_id}&lesson_id=${lesson_id}&unit_id=${unit_id}&teacher_id=${teacher_id}&class_date=${class_date}&teacher_name=${encodeURIComponent(teacher_name)}`;
        this.qrModalRef.open(qrCodeString, 'QR code do Rocket');
    }
}

    render() {

        return (
            <div className="Rocket Page">
                <div className="container">
                    <div className="header-section">
                        <h1>Registrar Rocket</h1>
                        <Breadcrumb segments={Rocket.breadcrumbSegments}
                            onClick={this.handleBreadcrumbClick.bind(this)}/>
                    </div>

                    <QrCodeModal ref={ref => (this.qrModalRef = ref)} title='QR code do Rocket'/>

                    <div className="dropdowns">
                    <div className="DropdownFilter qr-wrapper">
                        <DropdownRocketClass />
                        <DropdownLessonByDay />

                        <button
                            className="btn-generate-qrcode"
                            onClick={() => this.handleGenerateQRCode()}
                            disabled={
                            !this.props.SchoolStore.schoolSelected ||
                            !this.props.SchoolStore.classSelected ||
                            !this.props.SchoolStore.lessonSelected
                            }
                        >
                            Gerar QR Code
                        </button>
                    </div>

                    </div>

                </div>
            </div>
        )

    }

}


// WEBPACK FOOTER //
// ./src/containers/Rocket.js